import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function StaySection() {
  const {
    t
  } = useLanguage();
  return <section id="pronajem" className="relative bg-cream text-charcoal-900 overflow-hidden" data-id="element-196">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen" data-id="element-197">
        {/* Image Half */}
        <div className="relative h-[50vh] lg:h-auto order-2 lg:order-1" data-id="element-198">
          <div className="absolute inset-0 bg-charcoal-900/20 z-10" data-id="element-199"></div>
          <img src="https://cdn.magicpatterns.com/uploads/25k894Z1RN1JyEcxFVGo24/IMG_4065-2.jpg" alt="Historické schodiště s malbou a kovaným zábradlím" className="absolute inset-0 w-full h-full object-cover" data-id="element-200" />
        </div>

        {/* Content Half */}
        <div className="flex items-center justify-center p-8 md:p-16 lg:p-24 order-1 lg:order-2 bg-grain" data-id="element-201">
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="max-w-xl" data-id="element-202">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading leading-tight mb-6" data-id="element-203">
              {t.stay.heading1} <br data-id="element-204" />
              <span className="italic text-charcoal-800" data-id="element-205">
                {t.stay.heading2}
              </span>
            </h2>
            <p className="text-xl text-charcoal-800/80 font-light italic mb-12" data-id="element-206">
              {t.stay.subtitle}
            </p>

            <div className="space-y-10 mb-12" data-id="element-207">
              {t.stay.features.map((feature, index) => <div key={index} className="relative pl-8 border-l border-gold/30" data-id="element-208">
                  <div className="absolute left-[-5px] top-2 w-2 h-2 rounded-full bg-gold" data-id="element-209"></div>
                  <h3 className="text-xl font-heading font-bold mb-2" data-id="element-210">
                    {feature.title}
                  </h3>
                  <p className="text-charcoal-800/70 font-light leading-relaxed" data-id="element-211">
                    {feature.desc}
                  </p>
                </div>)}
            </div>

            <div className="bg-charcoal-900 text-cream p-8 mb-10" data-id="element-212">
              <h4 className="text-sm tracking-[0.2em] uppercase text-gold font-semibold mb-6" data-id="element-213">
                {t.stay.amenitiesLabel}
              </h4>
              <ul className="space-y-4 font-light" data-id="element-214">
                {t.stay.amenities.map((amenity, index) => <li key={index} className="flex items-start gap-3" data-id="element-215">
                    <span className="text-gold mt-1" data-id="element-216">•</span>
                    <span data-id="element-217">{amenity}</span>
                  </li>)}
              </ul>
            </div>

            <a href="#kontakt" className="inline-block px-8 py-4 border border-charcoal-900 text-charcoal-900 text-sm tracking-widest uppercase font-semibold hover:bg-charcoal-900 hover:text-cream transition-colors duration-300" data-id="element-218">
              {t.stay.cta}
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}